import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import loadjs from 'loadjs';
import classes from './SearchBarB.module.scss';

class SearchBarB extends React.Component {
  constructor(props) {
    super(props);
    const { inputText } = props;

    this.state = {
      inputText: inputText || '',
    };
    this.updateQueryString = this.updateQueryString.bind(this);
    this.clickSearch = this.clickSearch.bind(this);
  }

  componentDidMount() {
    const { siteSearch360SiteResults, siteSearch360SiteId, searchQueryString } = this.props;
    if (siteSearch360SiteId && siteSearch360SiteResults && typeof window !== 'undefined') {
      if (!window.SS360 && !loadjs.isDefined('sitesearch360')) {
        window.ss360Config = {
          siteId: siteSearch360SiteId,
          searchBox: {
            selector: `.${classes.search}`,
            searchButton: `.${classes.go}`,
          },
          results: {
            searchQueryParamName: searchQueryString,
            moreResultsButton: 'Show more results',
            moreResultsPagingSize: 10,
            embedConfig: {
              url: siteSearch360SiteResults,
              contentBlock: '#ss360results',
            },
          },
          suggestions: {
            show: false,
          },
        };
        loadjs(
          'https://cdn.sitesearch360.com/sitesearch360-v12.min.js',
          'sitesearch360',
          {
            before: (path, scriptEl) => {
              document.body.appendChild(scriptEl);
              /* return `false` to bypass default DOM insertion mechanism */
              return false; // Insert the script tag into the body tag and not the head tag
            },
          },
        );
      } else if (window.SS360) {
        // we need to constantly bind the library to the boxes so we dont get boxes that dont trigger search
        window.SS360.init();
      }
    }

    if (!siteSearch360SiteId || !siteSearch360SiteResults || typeof window === 'undefined') {
      return false;
    }

    return true;
  }

  clickSearch(clickevent) {
    const { inputText } = this.state;
    window.SS360.showResults(inputText);
    clickevent.stopPropagation();
    return false;
  }

  updateQueryString(query) {
    this.setState({ inputText: query });
  }

  render() {
    const { inputText } = this.state;
    const { searchBarRef } = this.props;
    return (
      <div className={classes.form}>
        <input
          required
          className={classes.search}
          type='text'
          placeholder='Search'
          value={inputText}
          onChange={(e) => this.updateQueryString(e.target.value)}
          aria-label='Search'
          ref={searchBarRef}
        />
        <button
          className={classes.go}
          type='submit'
          onClick={(e) => this.clickSearch(e)}
          aria-label='Search'
        >
          <FontIcon icon='far fa-search' />
        </button>
      </div>
    );
  }
}

SearchBarB.propTypes = {
  /**
   * Id for site search 360
  */
  siteSearch360SiteId: PropTypes.string,
  /**
   * Url for the results page to display results
  */
  siteSearch360SiteResults: PropTypes.string,
  /**
   * Search query string to submit results
  */
  searchQueryString: PropTypes.string,
  /**
   * Input text for search bar
  */
  inputText: PropTypes.string,
  /**
   * React ref for parent to control additional behavior
  */
  searchBarRef: PropTypes.object,
};

export default SearchBarB;
